const SERIES_ID_PATTERN = /^\d{1,30}$/;
const TERMINAL_STATUSES = new Set(['SUCCEEDED', 'FAILED', 'TIMED-OUT', 'ABORTED']);
const STORAGE_KEY = 'admin-hongguo:last-attempt:v1';

export const parseHongguoSeriesIds = (input, max = 10) => {
  const seriesIds = [...new Set(String(input).split(/[\s,，]+/u).map(value => value.trim()).filter(Boolean))];
  if (!seriesIds.length) return { seriesIds, error: '请至少输入一个剧集 ID。' };
  if (seriesIds.some(value => !SERIES_ID_PATTERN.test(value))) {
    return { seriesIds, error: '剧集 ID 必须为 1–30 位数字。当前仅支持 ID，不支持分享链接或剧名。' };
  }
  if (seriesIds.length > max) return { seriesIds, error: `去重后最多允许 ${max} 个剧集 ID，当前为 ${seriesIds.length} 个。` };
  return { seriesIds, error: '' };
};

export const isHongguoRunTerminal = status => TERMINAL_STATUSES.has(status);

export const formatHongguoValue = value => (
  (typeof value === 'string' && value.trim() !== '') || (typeof value === 'number' && Number.isFinite(value))
    ? String(value)
    : '未提供'
);

export const formatHongguoUsd = value => (
  typeof value === 'number' && Number.isFinite(value) && value >= 0
    ? `$${value.toFixed(6).replace(/0+$/, '').replace(/\.$/, '')} USD`
    : '未提供'
);

export const hongguoResultRows = (items, requestedIds = []) => {
  const rows = (Array.isArray(items) ? items : []).map((item, index) => {
    const record = item && typeof item === 'object' && !Array.isArray(item) ? item : {};
    const series = record.series && typeof record.series === 'object' && !Array.isArray(record.series) ? record.series : {};
    // No schema aliases or popularity estimates: these are the literal source fields.
    const seriesId = typeof record.seriesId === 'string' || Number.isSafeInteger(record.seriesId) ? String(record.seriesId) : '';
    return {
      key: `item-${index}`,
      seriesId,
      status: record.success === true ? '成功' : record.success === false ? '失败' : '未提供成功标记',
      title: formatHongguoValue(series.title),
      episodeCount: formatHongguoValue(series.episodeCount),
      playCount: formatHongguoValue(series.playCount),
      raw: item,
    };
  });
  const returnedIds = new Set(rows.map(row => row.seriesId).filter(Boolean));
  for (const seriesId of requestedIds) {
    if (!returnedIds.has(seriesId)) {
      rows.push({ key: `missing-${seriesId}`, seriesId, status: '未返回匹配记录', title: '未提供', episodeCount: '未提供', playCount: '未提供', missing: true });
    }
  }
  return rows;
};

export const readHongguoAttempt = () => {
  try {
    const saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
    if (!saved || typeof saved.requestId !== 'string') return null;
    return {
      requestId: saved.requestId.slice(0, 80),
      runId: typeof saved.runId === 'string' ? saved.runId.slice(0, 80) : null,
      seriesIds: Array.isArray(saved.seriesIds) ? saved.seriesIds.filter(id => typeof id === 'string' && SERIES_ID_PATTERN.test(id)).slice(0, 10) : [],
      status: 'RESTORED',
    };
  } catch {
    return null;
  }
};

export const saveHongguoAttempt = attempt => {
  try {
    if (!attempt) sessionStorage.removeItem(STORAGE_KEY);
    else sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ requestId: attempt.requestId, runId: attempt.runId || null, seriesIds: attempt.seriesIds || [] }));
  } catch {
    // Storage may be disabled. The current in-memory attempt still works.
  }
};
